
































import formatDate from '@/filters/DateFormatter';
import formatStoreLabel from '@/filters/StoreLabelFormatter';
import { Component, Vue } from "vue-property-decorator";
import { Inject } from "vue-typedi";
import {Slot} from "@/model/collection/Slot";
import {Drive} from "@/model/Drive";
import {SupportService} from "@/services/SupportService";
import {DriveService} from "@/services/DriveService";
import {Support} from "@/model/support/Support";

@Component({
  filters: {formatDate, formatStoreLabel}
})
export default class CollectionSlotSelection extends Vue {

  @Inject()
  supportService!: SupportService;
  @Inject()
  driveService!: DriveService;

  allDrives: Drive[] = [];
  allSlots: Slot[] = [];
  allCreatedSupports: Support[] = [];
  selectedDrive: Drive = null;
  selectedSlot: Slot = null;
  isInitialized: boolean = false;

  mounted() {
    const storeId = sessionStorage.getItem('storeId');
    this.fetchDrives(storeId);
    this.fetchSlots();
    this.isInitialized = true;
  }

  fetchSlots() {
    this.supportService.getCreatedSupports().then((res: Support[]) => {
      if (res == null) {
        return;
      }

      this.allCreatedSupports = res;
      const grouped = new Map<number, Slot>();

      this.allCreatedSupports
        .forEach(support => {
          const date = new Date(support.collectionSlot);
          const key = date.getTime();

          if (!grouped.has(key)) {
            grouped.set(key, {
              dueDate: new Date(date),
              driveIds: []
            });
          }

          grouped.get(key)!.driveIds.push(support.driveId);
        });

      this.allSlots = Array.from(grouped.values()).sort((a, b) => a.dueDate.getTime() - b.dueDate.getTime());
    });
  }

  fetchDrives(storeId: string) {
    this.driveService.getDrivesByStoreId(storeId)
      .then((res: Drive[]) => {
        this.allDrives = res.filter(drive => !drive.relay);
        this.initDriveSelection();
      })
  }

  initDriveSelection(): void {
    if (this.allDrives == null || this.allDrives.length !== 1) {
      return;
    }

    this.selectedDrive = this.allDrives[0];
  }

  onSelectedDriveChange(): void {
    this.selectedSlot = null;
  }

  onStartCollection(): void {
    const supportsToDropOff = this.allCreatedSupports.filter(support =>
      support.driveId === this.selectedDrive.driveId &&
      new Date(support.collectionSlot).getTime() ===
      this.selectedSlot.dueDate.getTime()
    );

    this.$emit('selectedSlot', {
      drive: this.selectedDrive,
      slot: this.selectedSlot,
      supportsToCollect: supportsToDropOff,
      allCreatedSupports: this.allCreatedSupports
    });
  }

  get filteredSlots(): Slot[] {
    if (this.selectedDrive == null) {
      return [];
    }

    return this.allSlots.filter(slot => slot.driveIds.includes(this.selectedDrive.driveId));
  }

  get hasSlots(): boolean {
    return this.filteredSlots != null && this.filteredSlots.length > 0;
  }

  get canStartCollection(): boolean {
    return this.selectedDrive != null && this.selectedSlot != null;
  }
}

